exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-pre-wedding-photos-tsx": () => import("./../../../src/pages/pre-wedding-photos.tsx" /* webpackChunkName: "component---src-pages-pre-wedding-photos-tsx" */),
  "component---src-pages-rsvp-tsx": () => import("./../../../src/pages/rsvp.tsx" /* webpackChunkName: "component---src-pages-rsvp-tsx" */)
}

